import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowDashed = () => {
  return (
    <g>
      <path d="m10.452 2.147.084.073 5.245 5.248a.75.75 0 0 1 .072.977l-.072.084-5.249 5.251a.75.75 0 0 1-1.133-.977l.073-.084 4.717-4.721L9.475 3.28a.75.75 0 0 1-.072-.977l.072-.084a.75.75 0 0 1 .977-.073zM5 7.997a.75.75 0 0 1-.75.751H.74a.745.745 0 0 1-.74-.75c0-.38.278-.694.64-.743l.1-.007h3.51a.75.75 0 0 1 .75.75zm5.76-.75c.409 0 .74.337.74.751 0 .38-.278.694-.64.744l-.1.007H7.25a.75.75 0 0 1 0-1.502h3.51z" />
    </g>
  );
};

export default withIcon(IconArrowDashed);
